import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useEffect } from 'react'
import { setModalOnClose } from 'slices/modal'
import { ROUTES } from 'app-constants'
import { StatusResponse } from './components'

function stages({ ...props }) {
  return {
    initial: <StatusResponse {...props} />,
  }
}

export function RequiredPasswordUpdate() {
  const { stage, data } = useSelector(({ modal }) => modal)
  const dispatch = useDispatch()
  const { push } = useHistory()

  useEffect(() => {
    function handleRedirectAfterClose() {
      push(ROUTES.HOME.PATH)
    }
    dispatch(setModalOnClose(handleRedirectAfterClose))
  }, [dispatch, push])

  return stages({ ...data })[stage]
}
